import { render, staticRenderFns } from "./Exports1099.vue?vue&type=template&id=146c2597&"
import script from "./Exports1099.vue?vue&type=script&lang=ts&"
export * from "./Exports1099.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports